import React from "react";
import { connect } from "react-redux";
import LoginSwitch from "./LoginSwitch.jsx";

// mapStateToProps is a react-redux specific function
// that injects the redux store, after filters. REQUIRED
//    state = reduxStore
//    ownProps = props passed to container Component (Not Meteor data)
const mapStateToProps = (state, ownProps) => {
	// console.log(state);
	// console.log(ownProps);
	return {
		codeDeliveryMessage: state.login.codeDeliveryMessage,
		createNewPassword: state.login.createNewPassword,
		forceChangePassword: state.login.forceChangePassword,
		forgotPassword: state.login.forgotPassword,
		loginInputChangePasswordNew: state.login.loginInputChangePasswordNew,
		loginInputChangePasswordOld: state.login.loginInputChangePasswordOld,
		loginError: state.login.loginError,
		loginErrorText: state.login.loginErrorText,
		loginInputEmail: state.login.loginInputEmail,
		loginInputPassword: state.login.loginInputPassword,
		loginInputVerificationCode: state.login.loginInputVerificationCode,
		loginInputNewPassword: state.login.loginInputNewPassword,
		userJustLoggedIn: state.login.userJustLoggedIn,
		validationInProgress: state.login.validationInProgress,
	};
};

// mapDispatchToProps is a react-redux specific
// function that binds a function into the props
// Default is: dispatch => ({ dispatch }), to this isn't necessary in simple uses
// const mapDispatchToProps = (dispatch, ownProps) => {
// 	return {
// 		didLoad: () => {
// 			dispatch(initialLoginLoaded());
// 		},
// 		dispatch: () => ({ dispatch }),
// 	};
// };

// const mergeProps = ( stateProps, actionProps, parentProps ) => ({
// ...stateProps,
// ...actionProps,
// ...parentProps
// });

// Combines everything, including Meteor data
const LoginContainer = connect(
	mapStateToProps
	// mapDispatchToProps
	// mergeProps
)(LoginSwitch);

export default LoginContainer;
